'use client';

import * as React from 'react';

import Image from 'next/image';

function Logo() {
    return (
        <Image src='/logo.svg' alt='logo' width={100} height={100} loading='eager' />
    );
}

export { Logo };
